
























































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { forOwn } from 'lodash'
import { Meta } from '@/helpers/decorators'

// Mixins
import TableMixin from '@/mixins/Table'
import DateMixin from '@/mixins/Date'
import FiltersMixin from '@/mixins/Filter'
import ItemsMixin from '@/mixins/Items'
import Errors from '@/mixins/Errors'

// Models
import ItemRow from '@/models/ItemRow'

// Components
import ImageViewerValue from '@/components/common/ImageViewerValue.vue'
import DateRanger from '@/components/common/DateRanger.vue'

// View
import ItemTopControls from '@/views/items/partials/ItemTopControls.vue'

@Component({
  components: { ImageViewerValue, DateRanger, ItemTopControls }
})
export default class ListAllMissions extends Mixins(TableMixin, DateMixin, FiltersMixin, ItemsMixin, Errors) {
  // Pagination
  offset = 0
  limit = 20
  end = false

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale


  @Watch('$route', { immediate: true })
  async fetchItemsWithParams(route) {
    this.offset = 0
    this.search = route.query.search ? route.query.search : null
    this.startDate = route.query.range ? route.query.range.split(',')[0] : null
    this.endDate = route.query.range ? route.query.range.split(',')[1] : null
    await this.fetch(false)
  }


  @Watch('locale')
  async updateDataWithCurrentLocale() {
    this.offset = 0
    await this.fetch(false)
  }

  @Meta
  metas() {
    return {
      title: this.$t('menu.fleet'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }


  get params(): {} {
    const params = {
      limit: this.limit,
      offset: this.offset
    }

    forOwn(this.$route.query, (value, key) => {
      params[key] = value
    })

    return params
  }

  goToReport(mission) {
    this.$router.push({ name: 'singleReport', params: { id: mission.report.proovCode } })
  }

  async fetch(add: boolean) {
    try {
      this.tableLoading = true
      const res = await this.$api.items.fetchItems(this.token, this.params)
      const items = res.data.map((item) => new ItemRow(item, this.locale))
      this.data = add ? [...this.data, ...items] : items
      this.end = items.length === 0
      this.offset += this.limit
    } finally {
      this.tableLoading = false
    }
  }

  async loadMore() {
    await this.fetch(true)
  }

  async mounted() {
    const res = await this.$api.items.fetchItems(this.token, this.params)
    this.firstLoad = false
    this.hasData = res.data.length > 0
  }

  goToItemReports(item) {
    this.$router.push({ name: 'itemReports', params: { id: item.id }, query: { title: item.value } })
  }

  deleteItem(id) {
    this.$dialog.confirm({
      title: this.$t('global.info_box.warning') as string,
      message: this.$t('item.actions.delete.message') as string,
      confirmText: this.$t('global.delete') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          const res = await this.$api.items.deleteItem(this.token, id)
          await this.fetch(false)
          this.$toast.open({
            message: this.$t('item.delete.notification.success') as string,
            type: 'is-success',
            duration: 5000
          })
        } catch (error) {
          this.displayErrors(error)
        }
      }
    })
  }
}
